import Link from "next/link";
import React from "react";

export default function ThankYou() {
  return (
    <div class="content">
      <div class="wrapper-1">
        <div class="wrapper-2">
          <h1>Thank you !</h1>
          <p>Your business is updated successfully</p>
          <Link href="/">
            <button class="go-home">go home</button>
          </Link>
        </div>
      </div>
    </div>
  );
}
